import { useCacheService } from '@fs/zion-cache-service'
import { cacheServiceOld } from './caches'

/**
 * Fetch group limits from backend.
 * @returns {unknown} Promise with max admins per group and max groups per user
 */
export default async function getGroupLimits() {
  return cacheServiceOld.get(`/service/tree/tree-data/groups/limits`, 'group-limits')
}

export const useGroupLimits = () => {
  return useCacheService(cacheServiceOld, `/service/tree/tree-data/groups/limits`, 'group-limits')
}
